export default class {
  constructor (data, type = 'xml') {
    this.data = data
    this.type = type
  }

  getXmlCode () {
    let data = '```xml' + this.data + '```'
    return data
  }
}



// WEBPACK FOOTER //
// ./src/data/FormatCode.js